<template>
  <div class="apartment-price-container">
    <div class="apartment-price-number">
      <span
        ><span v-if="currency === 'usd'">$</span><span v-else>&#8372;</span>
        {{ price | currencyFilter(currency) }}</span
      >
    </div>
    <div class="apartment-id-container ">
      <span>id: {{ id }}</span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ApartmentPrise',
  props: {
    price: Number,
    id: Number,
  },
  components: {},
  computed: {
    currency() {
      return this.$store.getters.getGlobalCurrency
    },
  },
}
</script>

<style scoped lang="scss">
.apartment-price-container {
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  margin-bottom: 4.8rem;

  .apartment-price-number {
    color: #016bf3;
    font-size: 2.8rem;
    font-family: 'Nunito-Bold', sans-serif;
    margin-bottom: 1.2rem;
  }

  .apartment-id-container {
    font-family: 'Nunito-Regular', sans-serif;
    font-size: 1.2rem;
    color: #4d4d4f;
    opacity: 0.5;
  }
}
</style>
